let toastContainer: HTMLElement | null = null;

function getContainer(): HTMLElement {
  if (toastContainer && document.body.contains(toastContainer)) return toastContainer;
  toastContainer = document.createElement('div');
  toastContainer.className = 'toasts';
  document.body.appendChild(toastContainer);
  return toastContainer;
}

export function pbToast(message: string, kind: 'ok' | 'err' = 'ok'): void {
  const container = getContainer();
  const el = document.createElement('div');
  el.className = `toast toast--${kind === 'err' ? 'risk' : 'ok'}`;
  el.textContent = message;
  container.appendChild(el);
  setTimeout(() => { el.remove(); }, 4000);
}
